export const OWNER_REGISTER_REQUEST = 'OWNER_REGISTER_REQUEST'
export const OWNER_REGISTER_SUCCESS = 'OWNER_REGISTER_SUCCESS'
export const OWNER_REGISTER_FAIL = 'OWNER_REGISTER_FAIL'
export const OWNER_REGISTER_RESET = 'OWNER_REGISTER_RESET'

export const OWNER_LOGIN_REQUEST = 'OWNER_LOGIN_REQUEST'
export const OWNER_LOGIN_SUCCESS = 'OWNER_LOGIN_SUCCESS'
export const OWNER_LOGIN_FAIL = 'OWNER_LOGIN_FAIL'
export const OWNER_LOGIN_RESET = 'OWNER_LOGIN_RESET'
export const OWNER_LOGOUT = 'OWNER_LOGOUT'

export const OWNER_DETAILS_REQUEST = 'OWNER_DETAILS_REQUEST'
export const OWNER_DETAILS_SUCCESS = 'OWNER_DETAILS_SUCCESS'
export const OWNER_DETAILS_FAIL = 'OWNER_DETAILS_FAIL'
export const OWNER_DETAILS_RESET = 'OWNER_DETAILS_RESET'

export const OWNER_UPDATE_PROFILE_REQUEST = 'OWNER_UPDATE_PROFILE_REQUEST'
export const OWNER_UPDATE_PROFILE_SUCCESS = 'OWNER_UPDATE_PROFILE_SUCCESS'
export const OWNER_UPDATE_PROFILE_FAIL = 'OWNER_UPDATE_PROFILE_FAIL'
export const OWNER_UPDATE_PROFILE_RESET = 'OWNER_UPDATE_PROFILE_RESET'

export const OWNER_DISABLE_REQUEST = 'OWNER_DISABLE_REQUEST'
export const OWNER_DISABLE_SUCCESS = 'OWNER_DISABLE_SUCCESS'
export const OWNER_DISABLE_FAIL = 'OWNER_DISABLE_FAIL'
export const OWNER_DISABLE_RESET = 'OWNER_DISABLE_RESET'

export const OWNER_DELETE_REQUEST = 'OWNER_DELETE_REQUEST'
export const OWNER_DELETE_SUCCESS = 'OWNER_DELETE_SUCCESS'
export const OWNER_DELETE_FAIL = 'OWNER_DELETE_FAIL'
export const OWNER_DELETE_RESET = 'OWNER_DELETE_RESET'
